import React from 'react';
import styled from 'styled-components';
import './Success.css';

const Check = styled.div`
    width: ${ (props) => props.width || 90 }px;
    height: ${ (props) => props.height || 130 }px;
    margin: 0 auto;
`;

const CheckWrapper = (props) =>
	(<Check { ...props } className="check-wrapper">
		<div className="sa-icon sa-success animate">
			<span className="sa-line sa-tip animateSuccessTip"/>
			<span className="sa-line sa-long animateSuccessLong"/>
			<div className="sa-placeholder"/>
			<div className="sa-fix"/>
		</div>
	</Check>);

export default CheckWrapper;
